import lazyScreen from '../utils/lazyScreen';
const EXROrders = lazyScreen(() => import('../pages/exr/EXROrders/index.js'), 'pages/exr/EXROrders/index.js');
const EXROrder = lazyScreen(() => import('../pages/exr/EXROrder/index.js'), 'pages/exr/EXROrder/index.js');
const EXRInvoices = lazyScreen(() => import('../pages/exr/EXRInvoices/index.js'), 'pages/exr/EXRInvoices/index.js');
const EXRInvoice = lazyScreen(() => import('../pages/exr/EXRInvoice/index.js'), 'pages/exr/EXRInvoice/index.js');
const EXROtherOrders = lazyScreen(() => import('../pages/exr/EXROtherOrders/index.js'), 'pages/exr/EXROtherOrders/index.js');
const EXROtherOrder = lazyScreen(() => import('../pages/exr/EXROtherOrder/index.js'), 'pages/exr/EXROtherOrder/index.js');
// Gói Kế toán (không có AR): tab Phải thu dùng tiền tố /sale/ để thanh điều hướng nhận đúng module; cùng trang với /exr/, /crm/, /tax/.
const SaleCustomers = lazyScreen(() => import('../pages/crm/Customers/index.js'), 'pages/crm/Customers/index.js');
const SaleCustomer = lazyScreen(() => import('../pages/crm/Customer/index.js'), 'pages/crm/Customer/index.js');
const SaleEmployees = lazyScreen(() => import('../pages/hrm/Employees/index.js'), 'pages/hrm/Employees/index.js');
const SaleEmployee = lazyScreen(() => import('../pages/hrm/Employee/index.js'), 'pages/hrm/Employee/index.js');
const SaleInvoicables = lazyScreen(() => import('../pages/tax/SaleInvoicables/index.js'), 'pages/tax/SaleInvoicables/index.js');
const SaleVATOutputReports = lazyScreen(() => import('../pages/tax/VATOutputReports/index.js'), 'pages/tax/VATOutputReports/index.js');

export default [
    {
        path: '/exr/EXROrders',
        component: EXROrders
    },
    {
        path: '/exr/EXROrder/:code',
        component: EXROrder
    },
    {
        path: '/exr/EXRInvoices',
        component: EXRInvoices
    },
    {
        path: '/exr/EXRInvoice/:code',
        component: EXRInvoice
    },
    {
        path: '/exr/EXROtherOrders',
        component: EXROtherOrders
    },
    {
        path: '/exr/EXROtherOrder/:code',
        component: EXROtherOrder
    },
    {
        path: '/sale/EXROrders',
        component: EXROrders
    },
    {
        path: '/sale/EXROrder/:code',
        component: EXROrder
    },
    {
        path: '/sale/EXROtherOrders',
        component: EXROtherOrders
    },
    {
        path: '/sale/EXROtherOrder/:code',
        component: EXROtherOrder
    },
    {
        path: '/sale/Customers',
        component: SaleCustomers
    },
    {
        path: '/sale/Customer/:code',
        component: SaleCustomer
    },
    {
        path: '/sale/Employees',
        component: SaleEmployees
    },
    {
        path: '/sale/Employee/:code',
        component: SaleEmployee
    },
    {
        path: '/sale/SaleInvoicables',
        component: SaleInvoicables
    },
    {
        path: '/sale/VATOutputReports',
        component: SaleVATOutputReports
    }
];
